<div class="govuk-width-container">

    <div class="row">
        <nav class="col-12 col-md-4" aria-label="Side navigation">
            <p class="govuk-body h-100"><app-menu></app-menu></p>
        </nav>
        <main class="govuk-main-wrapper col-12 col-md-8 pt-0" id="main-content" tabindex="-1">
            <h1 class="govuk-heading-xl">My Ceremony</h1>
            <div class="govuk-notification-banner app-notification-banner" role="region"
                aria-labelledby="govuk-notification-banner-title" data-module="govuk-notification-banner">
                <ng-container *ngIf="bookings.length > 0">
                    <div class="govuk-notification-banner__header">
                        <h2 class="govuk-notification-banner__title" id="govuk-notification-banner-title">
                            Congratulations!
                        </h2>
                    </div>
                    <div class="govuk-notification-banner__content">
                        <p class="govuk-notification-banner__heading">
                            <span class="secondary-text">
                                The {{ceremony.service_name}}
                            </span>
                            of {{ (party1Name.length > 0) ? party1Name : '' }} &
                            {{ (party2Name.length > 0) ? party2Name : '' }}
                            {{ceremony.shortdate}}
                            {{ceremony.just_time}}
                        </p>
                    </div>
                </ng-container>
                <ng-container *ngIf="bookings.length < 1">
                    <div class="govuk-notification-banner__header">
                        <h2 class="govuk-notification-banner__title" id="govuk-notification-banner-title">
                            No bookings found
                        </h2>
                    </div>
                </ng-container>
            </div>
            <app-custom-object-banner page="our-ceremony"></app-custom-object-banner>
            <!--
            <div class="govuk-form-group govuk-password-input" data-module="govuk-password-input">
                <label class="govuk-label" for="password-input">
                    Password
                </label>
                <div class="govuk-input__wrapper govuk-password-input__wrapper">
                    <input class="govuk-input govuk-password-input__input govuk-js-password-input-input" id="password-input" name="password" type="password" spellcheck="false" autocomplete="current-password" autocapitalize="none">
                    <button type="button" class="govuk-button govuk-button--secondary govuk-password-input__toggle govuk-js-password-input-toggle" data-module="govuk-button" aria-controls="password-input" aria-label="Show password" hidden>
                    Show
                    </button>
                </div>
                </div>
            -->
            <ng-container *ngIf="ceremony">
                <h2>Booking information</h2>
                <dl class="govuk-summary-list">
                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key">
                            Booking ID:
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{ceremony.id}}
                        </dd>
                    </div>
                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key">
                            Venue:
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{venueName}}
                        </dd>
                    </div>
                </dl>

                <h2>Selected time &amp; date</h2>
                <dl class="govuk-summary-list">
                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key">
                            Date:
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{ceremony.just_date}}
                        </dd>
                    </div>
                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key">
                            Time:
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{ceremony.just_time}}
                        </dd>
                    </div>

                </dl>

                <div class="row amend-buttons-wrapper">
                    <div class="col-12 amend-buttons flex-wrap gap-3">
                        <button *ngIf="canPurchaseAddons" type="button" class="btn btn-primary" data-module="govuk-button" (click)="navigate('/add-ons/before-you-start')">
                            Add ons
                        </button>

                        <button *ngIf="canReschedule" type="button" class="btn btn-primary" data-module="govuk-button" (click)="navigate('/reschedule/before-you-start')">
                            Reschedule
                        </button>

                        <button *ngIf="canCancel" type="button" class="btn btn-primary" data-module="govuk-button" (click)="navigate('/cancel/before-you-start')">
                            Cancel
                        </button>
 
                        <button *ngIf="canExtend && !alreadyExtended" type="button" class="btn btn-primary" data-module="govuk-button"
                            (click)="navigate('/extend/before-you-start')">
                            Extend
                        </button>
                    </div>

                </div>

                <button *ngIf="modifyBtnShow" type="button" class="govuk-button govuk-button--secondary"
                    data-module="govuk-button">
                    Modify my date &amp; time
                </button>

                <h2>My information</h2>
                <dl class="govuk-summary-list">
                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key">
                            Lead contact:
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{ leadBooker.name }}
                        </dd>
                    </div>
                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key">
                            Lead email:
                        </dt>
                        <dd class="govuk-summary-list__value">
                            {{ leadBooker.email }}
                        </dd>
                    </div>
                    <div class="govuk-summary-list__row">
                        <dt class="govuk-summary-list__key">
                            Lead phone number:
                        </dt>
                        <dd class="govuk-summary-list__value">
                            0{{ leadBooker.mobile }}
                        </dd>
                    </div>
                </dl>
            </ng-container>
            <ng-container *ngIf="!ceremony">
                <p>No ceremony found.</p>
            </ng-container>
        </main>
    </div>

</div>
